import React from 'react';
import { useInView } from './useInView';

type RevealProps = {
  as?: keyof JSX.IntrinsicElements;
  delay?: number;
  className?: string;
  children: React.ReactNode;
};

/**
 * Wrap a section/element to fade-up into view on scroll. Honors the
 * `prefers-reduced-motion` rule via index.css (which short-circuits the
 * transition durations).
 *
 * Visual-only: no layout effect, never blocks interaction.
 */
export function Reveal({ as = 'div', delay = 0, className = '', children }: RevealProps) {
  const { ref, inView } = useInView<HTMLElement>();
  const Tag = as as any;

  return (
    <Tag
      ref={ref}
      data-reveal={inView ? 'in' : 'out'}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      className={className}
    >
      {children}
    </Tag>
  );
}
